import { GET_SCALES, SCALE_ERROR, LOADING_SCALES } from "../actions/types";

const initialState = {
  scales: [],
  loading: true,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SCALES:
      return {
        ...state,
        scales: payload,
        loading: false,
      };
    case SCALE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case LOADING_SCALES:
      return {
        ...state,
        scales: [],
        loading: true,
      };
    default:
      return state;
  }
}
